import axios from 'axios';
import store from '../store';
import router from '../router';

export default function setup() {
  // request interceptor
  axios.interceptors.request.use(
    function(config) {
      const token = store.getters['auth/token'];
      if (token) {
        config.headers.Authorization = 'Bearer ' + token;
      }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );
  // response interceptor
  axios.interceptors.response.use(
    response => {
      if (response.data.token) {
        store.dispatch('auth/setToken', response.data.token);
      }
      return response;
    },
    error => {
      if (
        router.currentRoute.path !== '/login' &&
        401 === error.response.status
      ) {
        store.dispatch('auth/logout').then(() => {
          router.push('/login');
        });
      } else {
        return Promise.reject(error);
      }
    }
  );
}
